import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';
import createButtons from './createButtons';
import createButtonGroup from './createButtonGroup';
import createFab from './createFab';
import createTextField from './createTextField';
import createChip from './createChip';
import createContainer from './createContainer';
import createAppbar from './createAppbar';
import createPaper from './createPaper';
import createDialog from './createDialog';
import createLink from './createLink';
import createBreadcrumbs from './createBreadcrumbs';
import createDivider from './createDivider';
import createAutocomplete from './createAutocomplete';
import createStack from './creaetStack';
import createProgress from './createProgress';
import createMenu from './createMenu';
import createBadge from './createBadge';
import createSvgIcon from './createSvgIcon';

const createComponent = (theme: Theme): Components => {
  return {
    ...createButtons(theme),
    ...createButtonGroup(theme),
    ...createFab(theme),
    ...createTextField(theme),
    ...createChip(theme),
    ...createContainer(theme),
    ...createAppbar(theme),
    ...createBreadcrumbs(theme),
    ...createDivider(theme),
    ...createAutocomplete(theme),
    ...createPaper(),
    ...createDialog(theme),
    ...createLink(),
    ...createProgress(),
    ...createStack(),
    ...createMenu(theme),
    ...createBadge(),
    ...createSvgIcon(),
  };
};

export default createComponent;
